module.exports = __webpack_public_path__ + "img/Gabriel Martinelli.7fdd79f8.png";